import { MODAL_OPEN_REQUEST, MODAL_CLOSE_REQUEST } from './constants';

const INITIAL_STATE = {
  isOpen: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_OPEN_REQUEST: {
      return {
        isOpen: true
      };
    }
    case MODAL_CLOSE_REQUEST: {
      return {
        isOpen: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
